/**
 * --------------------------------------------------
 * Add event listeners to form elements for animation
 * @module forms
 * @see module:forms
 * --------------------------------------------------
 */

export default {

    selectedClassName: 'selected',
    dirtyClassName: 'isDirty',

    find: function (sel) {
        const _self = this;

        // Listen, listen!
        $(sel).on('focusin change', function (e) {
            _self._checkSelected(e.currentTarget);
        });

        $(sel).on('focusout', function (e) {
            _self._checkSelected(e.currentTarget);
        });
        
        // Store interval ID so we can clear it
        const intervalId = setInterval(function() {

            // Check all inputs on each interval
            _self._checkAllDirty(sel);

            // Use a local variable to check if all fields are dirty
            let allDirty = true;
            $(sel).each(function() {
                if (!$(this).hasClass(_self.dirtyClassName)) {
                    allDirty = false;
                    return false; // break loop
                }
            });

            // If all fields are dirty, clear the interval
            if (allDirty) {
                clearInterval(intervalId);
            }
        }, 100);
    },

    _checkSelected: function(sel) {
        const _self = this;
        const $elem = $(sel);
        const $checkType = $elem.find('input[type="radio"], input[type="checkbox"]');

        if ($checkType.length > 0) {
            return;
        } else {
            $elem.toggleClass(_self.selectedClassName);
            _self.isEmpty($elem);
        }
    },

    isEmpty: function ($inputWrapper) {
        const $input = $inputWrapper.find('input');
        
        if ($input.length && !$input.val()) {
            $inputWrapper.removeClass(this.dirtyClassName);
        } else {
            $inputWrapper.addClass(this.dirtyClassName);
        }
    },

    // Helper function to check all inputs on page load
    _checkAllDirty: function(sel) {
        var _self = this;
        var $inputs = $(sel);
        $inputs.each(function() {
            _self.isEmpty($(this));
        });
    }
}
